module.exports = __webpack_public_path__ + "static/media/r2.f04a7ab3.jpg";